





$(document).ready(function() { 
  if($(window).width() >= 992) { 
  

  $('.p-detail-inner > .row > .col-md-4:nth-child(1)').addClass('pull-right'); 
  $('.p-detail-inner > .row > .col-md-4:nth-child(1) + .col-md-8').removeClass('pull-right').addClass('pull-left');
 } else { 

} 
});

$('<p>'+freeShipping+'</p>').insertAfter('.add-to-cart.col-xs-6.col-md-12');


$('.contact_img').insertBefore('h1');

if ($('.type-product h1:contains("'+nausnice+'"), .type-product h1:contains("'+nausnice+'")').length > 0) {
  	$(".variant-list.velprst").hide();
}
$( 'a[href*="#ratingTab"]' ).parent().hide();





if ( $('#navigation-1 a span').text() === kamenyObchod ) {
    $('.order-availability').hide();
  }



$('.news-item-detail h1[itemprop*="headline"]').each(function() {
    if($(this).text().match(tipyNaVanocniDarky)) {
        $('body').addClass(tipy);
$('<div class="produkty"></div>').insertAfter('.text')
$('.produkty').load(darkovePoukazy+' #products');
    }
});
$( document ).ajaxComplete(function( ) {
$('div.content-inner .produkty div.products .product:nth-child(4) .img img').attr('src', 'https://www.zlatnictvisalaba.cz/user/shop/detail/324_dp30000.jpg');

});



if($('body').hasClass(tipy)) {

color = $('.produkty .img img').attr('data-src');
  $('.produkty .img img').attr('src', 'aaaa');
};






$('<span>'+pozdejProces+'</span>').appendTo(sperky);

$('body.type-category h1.h1').prependTo('.category-perex');
$('.category-perex:nth-child(1)').insertBefore('#content-wrapper').wrap('<section class="hlavapopis content-wrapper"><div class="container"></div></section>');


$('.recenze .container.last').load('/hodnoceni-produktu/ main#content .kn_latest-contribution-wrapper');